// extracted by extract-css-chunks-webpack-plugin
module.exports = {"seller-directory-page":"seller-directory-page___1a5SQ","title":"title___KgM1p","description":"description___hKhJM","throbber-message":"throbber-message___MjjUC"};